import { render, staticRenderFns } from "./addressBook.vue?vue&type=template&id=52be87fd&scoped=true&"
import script from "./addressBook.vue?vue&type=script&lang=js&"
export * from "./addressBook.vue?vue&type=script&lang=js&"
import style0 from "./addressBook.vue?vue&type=style&index=0&id=52be87fd&prod&scoped=true&lang=less&"
import style1 from "./addressBook.vue?vue&type=style&index=1&id=52be87fd&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52be87fd",
  null
  
)

export default component.exports